/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillDetailVo } from './BillDetailVo';
import {
    BillDetailVoFromJSON,
    BillDetailVoFromJSONTyped,
    BillDetailVoToJSON,
    BillDetailVoToJSONTyped,
} from './BillDetailVo';

/**
 * 
 * @export
 * @interface ResponseBillDetailVo
 */
export interface ResponseBillDetailVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBillDetailVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBillDetailVo
     */
    message?: string;
    /**
     * 
     * @type {BillDetailVo}
     * @memberof ResponseBillDetailVo
     */
    data?: BillDetailVo;
}

/**
 * Check if a given object implements the ResponseBillDetailVo interface.
 */
export function instanceOfResponseBillDetailVo(value: object): value is ResponseBillDetailVo {
    return true;
}

export function ResponseBillDetailVoFromJSON(json: any): ResponseBillDetailVo {
    return ResponseBillDetailVoFromJSONTyped(json, false);
}

export function ResponseBillDetailVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBillDetailVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BillDetailVoFromJSON(json['data']),
    };
}

export function ResponseBillDetailVoToJSON(json: any): ResponseBillDetailVo {
    return ResponseBillDetailVoToJSONTyped(json, false);
}

export function ResponseBillDetailVoToJSONTyped(value?: ResponseBillDetailVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BillDetailVoToJSON(value['data']),
    };
}

